import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/avatar.jpg'


const _withScopeId = n => (_pushScopeId("data-v-5a967dee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-bar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "first" }, null, -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "user" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "image",
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))

import { useRouter, useRoute } from 'vue-router'
import { ref, watch } from 'vue'
import { LOGIN_TOKEN } from '@/global/constants'
import { localCache } from '@/utils/cache'
import useLoginStore from '@/stores/modules/login'
import { storeToRefs } from 'pinia'


export default {
  __name: 'index',
  emits: 'quit',
  setup(__props, { emit }) {



const loginStore = useLoginStore()
const { userInfo } = storeToRefs(loginStore)
const localCacheUserInfo = localCache.getCache('userInfo')

const router = useRouter()
const route = useRoute()

const items = [
  { name: '我的信息', path: '/user' },
  { name: '旅行社购票', path: '/travelBuy' },
  // { name: '随星游购票', path: '/starBuy' },
  { name: '订单管理', path: '/manage' },
  { name: '修改密码', path: '/change' },
  { name: '资料下载', path: '/down' },
  { name: '购票公告', path: '/notice' }
]

const currentIndex = ref(0)

watch(route, (newRoute) => {
  let path = newRoute.path
  // if (path === '/starPayment') path = '/starBuy'
  // if (path === '/starPassenger') path = '/starBuy'
  if (path === '/travelPassenger') path = '/travelBuy'
  if (path === '/travelPaymentShip') path = '/travelBuy'
  if (path === '/travelPaymentCover') path = '/travelBuy'
  if (path === '/manageShip') path = '/manage'
  if (path === '/manageStar') path = '/manage'
  if (path === '/manageCover') path = '/manage'
  const index = items.findIndex((item) => item.path === path)
  if (index === -1) return
  currentIndex.value = index
})

// 点击
const itemClick = (index, path) => {
  currentIndex.value = index
  router.push(path)
}

// 退出
function handleExitClick() {
  localCache.removeCache(LOGIN_TOKEN)
  localCache.removeCache('userInfo')
  loginStore.loginAccountReset()
  emit('quit')
  router.push('/login')
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
      return _createElementVNode("span", {
        key: index,
        class: _normalizeClass(["item", { active: currentIndex.value === index }]),
        onClick: $event => (itemClick(index, item.path))
      }, _toDisplayString(item.name), 11, _hoisted_3)
    }), 64)),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(userInfo)?.UserName || _unref(localCacheUserInfo)?.UserName), 1),
      _hoisted_7,
      _createElementVNode("span", {
        class: "item",
        onClick: handleExitClick
      }, "安全退出")
    ])
  ]))
}
}

}